import React from "react";
import { TabPanelWrap } from "./Tabs.style";

/**
 * TabPanel – role="tabpanel", aria-labelledby, id for aria-controls.
 */
export default function TabPanel({
  tabKey,
  tabId,
  children,
  active,
  labelledBy,
  contentClassName,
  ...rest
}) {
  return (
    <TabPanelWrap
      id={tabId}
      role="tabpanel"
      aria-labelledby={labelledBy}
      tabIndex={0}
      hidden={!active}
      className={contentClassName}
      {...rest}
    >
      {children}
    </TabPanelWrap>
  );
}
